<template>
	<div>
		<div class="mianPage">
			<div class="topSearch">
				<el-form inline class="el-form flex_start">
					<el-form-item>
						<el-date-picker v-model="datePicker" value-format="yyyy-MM" type="monthrange" range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期" size="small">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.companyId" filterable clearable size="small" placeholder="请选择所属公司">
							<el-option v-for="item in companyOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.checkStatus" clearable size="small" placeholder="请选择核对状态">
							<el-option label="未核对" :value="0"></el-option>
							<el-option label="已核对" :value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.remitStatus" clearable size="small" placeholder="请选择打款状态">
							<el-option label="未打款" :value="0"></el-option>
							<el-option label="已打款" :value="1"></el-option>
						</el-select>
					</el-form-item>
					<div class="menu-right">
						<el-button @click="searchReset" size="small" v-hasPermi="['financeAccount:recordPayment:query']">重置</el-button>
						<el-button type="primary" @click="confirmQuery" size="small" v-hasPermi="['financeAccount:recordPayment:query']">查询</el-button>
					</div>
				</el-form>
			</div>
			<!-- table表格 -->
			<div class="tableBox">
				<el-table :max-height="560" :header-cell-style="{color:'#333333',background:'#EAEFF5'}" :data="tableData"
					class="el_table"  ref="multipleTable">
					<!-- @selection-change="handleSelectionChange" -->
					<!-- <el-table-column type="selection" :selectable="checkSelectable" width="55">
					</el-table-column> -->
					<el-table-column prop="month" label="账单月份"></el-table-column>
					<el-table-column prop="companyName" label="公司名称" width="200"></el-table-column>
					<el-table-column prop="cooperationState" label="合作状态">
						<template slot-scope="scope">
							<div v-if="scope.row.cooperationState === 1">未合作</div>
							<div v-if="scope.row.cooperationState === 2">合作中</div>
							<div v-if="scope.row.cooperationState === 3">跟进中</div>
							<div v-if="scope.row.cooperationState === 4">暂停合作</div>
							<div v-if="scope.row.cooperationState === 5">其他</div>
						</template>
					</el-table-column>
					<el-table-column prop="profit" label="收益"></el-table-column>
					<el-table-column prop="cut" label="核减"></el-table-column>
					<el-table-column prop="cut" label="核减后收益"></el-table-column>
					<el-table-column prop="invoiceDiff" label="发票差价%"></el-table-column>
					<el-table-column prop="cut" label="增值税差价%"></el-table-column>
					<el-table-column prop="finalProfit" label="结算金额"></el-table-column>
					<el-table-column prop="checkStatus" label="核对状态">
						<template slot-scope="scope">
							<div v-if="scope.row.checkStatus === 0">未核对</div>
							<div v-if="scope.row.checkStatus === 1">已核对</div>
						</template>
					</el-table-column>
					<el-table-column prop="remitStatus" label="打款状态">
						<template slot-scope="scope">
							<div v-if="scope.row.remitStatus === 0">未打款</div>
							<div v-if="scope.row.remitStatus === 1">已打款</div>
						</template>
					</el-table-column>
					<el-table-column prop="" label="查看文件" fixed="right" width="120">
						<template slot-scope="scope">
							<el-button type="text" @click="viewFun(scope.row)"
							v-hasPermi="['financeAccount:recordPayment:download']">查看</el-button>
						</template>
					</el-table-column>
					<el-table-column prop="" label="操作" fixed="right" width="200">
						<template slot-scope="scope">
							<el-button type="text" :disabled="!scope.row.mediaBillFileRecord"
								v-if="scope.row.checkStatus===0" @click="checkFun(scope.row,1) "
								v-hasPermi="['financeAccount:recordPayment:check']">核对</el-button>
							<el-button type="text" v-else :disabled="scope.row.remitStatus===1"
								@click="checkFun(scope.row,0) " v-hasPermi="['financeAccount:recordPayment:check']">取消核对</el-button>
							<el-button type="text" v-if="scope.row.remitStatus === 1" :disabled="true">已打款</el-button>
							<el-button type="text" v-else @click="paymentFun(scope.row) "
								:disabled="scope.row.checkStatus===0" v-hasPermi="['financeAccount:recordPayment:payment']">打款</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="paging" style="display: flex;justify-content: flex-end;margin-top: 20px;">
					<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange" :current-page="currentPage"
						:page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
						:total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-drawer @close="closeDrawer" :visible.sync="fileDrawerShow" size="48%" :wrapperClosable="true"
			:with-header="false">
			<el-card class="box-card">
				<div slot="header" class="cardTitle space_between">
					<div class="cardTitleTxt">公司信息</div>
					<i class="el-icon-circle-close" @click="fileDrawerShow=false"></i>
				</div>
				<div class="titleRow">
					<div class="drawerTipsTitle">关联结算单</div>
				</div>
				<div class="drawerContBox">
					<div class="drawTableRow">
						<div class="rowContent">结算总金额：{{drawerForm.finalProfit}}</div>
						<div class="rowContent">结算单总数：1</div>
					</div>
					<div class="drawTableRowTwo">
						<div class="rowContent">业务时间：{{drawerForm.month}}</div>
						<!-- <div class="rowContent">合作类型：展现</div> -->
						<div class="rowContent">核算金额：{{drawerForm.finalProfit}}</div>
					</div>
				</div>
				<div class="titleRow">
					<div class="drawerTipsTitle">已上传文件</div>
					<div class="downloadBtn" @click="downloadFileAll" v-if="drawerFileList.length>0">
						{{downloadAllLoading ? '下载中...' : '下载全部'}}
					</div>
				</div>
				<div class="drawerContBox">
					<div class="drawTableRowTwo" v-for="item in drawerFileList">
						<div class="fileCont" @click="downloadFile(item)">{{item.fileName}}</div>
					</div>
				</div>
			</el-card>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				mainHeadTitle: '媒体对账单',
				datePicker: [],
				appSelectData: [], // APP下拉选择列表
				companyOptions: [], // 公司下拉选择列表
				queryData: {},
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				appRulesApi: {
					adName: [{
						required: true,
						message: '请选择所属应用',
						trigger: 'blur'
					}, ],
					downloadLink: [{
						required: true,
						message: '请输入下载地址',
						trigger: 'blur'
					}, ],
				},
				appFormData: {
					isList: 1
				},

				dialogVisible: false, // 弹框显隐
				handleSelection: [], // 表格选中项
				
				drawerForm: {},
				fileDrawerShow: false,
				drawerFileList: [],
				downloadAllLoading: false // 下载全部进行状态，防止重复触发下载
			}
		},
		mounted() {
			this.getCompanyOption();
			// this.getAppOption();
			this.getTableData();
		},
		methods: {
			// 获取公司下拉列表
			async getCompanyOption() {
				let res = await this.$http.get(this.$api.common.companyOption);
				this.companyOptions = res.data
			},
			async getTableData() {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize,
					// appId: this.queryData.appId,
					startMonth: '',
					endMonth: '',
				}
				if (this.datePicker && this.datePicker.length>0) {
					data.startMonth = this.datePicker[0];
					data.endMonth = this.datePicker[1];
				}
				data = {...data,...this.queryData}
				let res = await this.$http.post(this.$api.financeAccount.mediaAccountList, data);
				this.tableData = res.data.list
				this.total = res.data.totalRecord
			},
			async getAppOption(){
				let res = await this.$http.get(this.$api.common.appOption);
				if(res.code == 1){
					this.appSelectData = res.data
				}
			},
			handleSizeChange(val) {
				this.currentPage = 1
				this.pageSize = val
				this.getTableData();
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getTableData();
			},
			searchReset() {
				this.currentPage = 1
				this.datePicker = []
				this.queryData = {}
				this.getTableData();
			},
			confirmQuery() {
				this.currentPage = 1
				this.getTableData();
			},
			// 同步
			async syncFun(row) {
				let data = row.length ? row : [row];
				let res = await this.$http.post(this.$api.companyList,data);
				if (res.code == 1) {
					this.getTableData(); // 刷新
					this.$message.success('同步成功！');
				}
			},
			// 生成结算单
			settlementDocFun(row){
				this.$confirm('此操作将生成结算单, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let arr = []
					arr.push(row.id)
					let res = await this.$http.post(this.$api.companyList,arr);
					if(res.code == 1){
						this.$message.success('结算单生成成功')
						this.getTableData(); // 刷新
					}
				}).catch();
			},
			// 计算
			async calculationFun(row) {
				let data = [];
				if (row === "all") {
					data = this.handleSelection;
				} else {
					data.push({
						"reviewReduce": row.cut,
						"id": row.id
					})
				}
				let res = await this.$http.post(this.$api.companyList,data);
				if(res.code == 1){
					this.$message.success('计算成功！');
					this.getTableData(); // 刷新
				}else{
					this.$message.warning('计算失败！');
				}
			},
			// 一键同步
			syncAllFun() {
				let data = this.handleSelection;
				if (data === "" || !data.length) {
					this.$message.warning("请选择同步项！");
					return
				}
				data = data.map(item => {
					return item.id
				})
				this.$confirm('此操作将同步收入, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$refs.multipleTable.clearSelection(); // 清空选项
					this.syncFun(data);
				}).catch();
			},
			// 复选框
			handleSelectionChange(val) {
				this.handleSelection = val.map(res => {
					return {
						"reviewReduce": res.cut,
						"id": res.id
					}
				})
			},
			
			// 复选框控制
			checkSelectable(row, index) {
				return true
			},
			// 设置核对状态
			checkFun(row, status) {
				this.$confirm('此操作将改变核对状态, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let data = {
						id: row.id,
						checkStatus: status
					}
					let res = await await this.$http.post(this.$api.financeAccount.setCheck,data);
					if (res.code == 1) {
						this.$message.success('核对状态修改成功')
						this.getTableData(); // 刷新
					}
				}).catch();
			},
			// 设置打款状态
			paymentFun(row) {
				this.$confirm('此操作将改变打款状态, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let data = {
						id: row.id,
						remitStatus: 1
					}
					let res = await this.$http.post(this.$api.financeAccount.setRemit,data);
					if (res.code == 1) {
						this.$message.success('打款成功')
						this.getTableData(); // 刷新
					}
				}).catch();
			},
			// 查看
			async viewFun(row) {
				this.drawerForm = row
				this.drawerFileList = []
				if(this.drawerForm.mediaBillFileRecord&&this.drawerForm.mediaBillFileRecord.length>0){
					this.drawerFileList = this.drawerForm.mediaBillFileRecord
				}
				this.fileDrawerShow = true
			},
			closeDrawer() {
				this.fileDrawerShow = false
			},
			/**
			 * 下载全部文件，单个文件下载失败时不影响其他文件继续下载
			 */
			async downloadFileAll() {
				if (!this.drawerFileList.length || this.downloadAllLoading) {
					return
				}
				this.downloadAllLoading = true
				try {
					// 下载结果用于统一提示成功和失败的文件数量
					const downloadResults = await Promise.all(this.drawerFileList.map(item => {
						return this.downloadFile(item, false)
					}))
					// 下载失败数量，用于反馈部分文件下载失败的情况
					const failCount = downloadResults.filter(result => !result).length
					if (failCount === 0) {
						this.$message.success('全部文件下载成功')
					} else {
						this.$message.warning(`${failCount}个文件下载失败，请重试`)
					}
				} finally {
					this.downloadAllLoading = false
				}
			},
			/**
			 * 将文件原地址转换为自定义文件域名地址
			 * @param {String} fileUrl 文件原地址
			 * @returns {String} 转换后的文件下载地址
			 */
			getFileDownloadUrl(fileUrl) {
				const domainEndFlag = '.com' // 原文件域名结束标识
				const domainEndIndex = fileUrl.indexOf(domainEndFlag) // 原文件域名结束位置
				if (domainEndIndex === -1) {
					return fileUrl
				}
				const fileDomain = 'https://file.ssp.richmob.cn/' // 自定义文件访问域名
				const filePath = fileUrl.substring(domainEndIndex + domainEndFlag.length).replace(/^\/+/, '') // 文件相对路径
				return fileDomain + filePath
			},
			/**
			 * 请求文件内容后通过临时地址下载，避免 PDF 在当前页面直接预览
			 * @param {Object} item 文件信息
			 * @param {Boolean} showError 是否显示单个文件的失败提示
			 * @returns {Promise<Boolean>} 文件是否成功触发下载
			 */
			async downloadFile(item, showError = true) {
				try {
					if (!item || !item.url) {
						throw new Error('文件下载地址不存在')
					}
					const downloadUrl = this.getFileDownloadUrl(item.url) // 自定义域名文件下载地址
					// 文件响应对象，用于校验请求状态并转换为 Blob
					const response = await fetch(downloadUrl)
					if (!response.ok) {
						throw new Error('文件请求失败')
					}
					// 临时文件地址为当前页面同源地址，可确保 download 属性生效
					const fileUrl = window.URL.createObjectURL(await response.blob())
					const downloadLink = document.createElement('a') // 触发浏览器保存文件的临时链接
					downloadLink.href = fileUrl
					downloadLink.download = item.fileName || '下载文件'
					downloadLink.style.display = 'none'
					document.body.appendChild(downloadLink)
					downloadLink.click()
					document.body.removeChild(downloadLink)
					// 延迟释放临时地址，确保浏览器已开始读取文件内容
					setTimeout(() => window.URL.revokeObjectURL(fileUrl), 100)
					return true
				} catch (error) {
					if (showError) {
						this.$message.error(`${item && item.fileName ? item.fileName : '文件'}下载失败，请重试`)
					}
					return false
				}
			},
		},
	}
</script>

<style scoped>
	.mianPage {
		padding: 10px;
	}
	
	.topSearch {
		background: #ffffff;
		padding: 16px;
		padding-bottom: 6px;
		border-radius: 4px;
	}
	
	.el-form {
		flex-wrap: wrap;
	}
	
	/deep/ .el-form--inline .el-form-item {
		margin-right: 20px !important;
	}
	/deep/ .el-form-item {
		margin-right: 10px !important;
		margin-bottom: 10px;
	}
	
	.menu-right {
		margin-left: auto;
		margin-top: 4px;
		/* margin-bottom: 20px; */
	}
	
	.tableBox {
		margin-top: 10px;
		background: #ffffff;
		padding: 16px;
		border-radius: 4px;
	}

	.cardTitle {
		font-weight: 500;
		font-size: 22px;
		color: #000000;
	}

	.cardTitle i {
		cursor: pointer;
	}

	.cardTitleTxt {
		font-size: 16px;
	}

	.box-card {
		height: 100%;
	}

	.box-card /deep/ .el-form--inline .el-form-item {
		display: block !important;
	}

	.card-bottom {
		padding-right: 30px;
	}




	.pageTopBox {
		height: 54px;
		width: 100%;
		/* border-left: 3px solid #4568dc; */
		box-shadow: 0 3px 15px rgb(0 0 0 / 5%);
		padding: 0 20px;
		box-sizing: border-box;
		background: #FFFFFF;
		align-items: center;
	}

	.addBtn {
		padding-right: 5px;
	}

	.titleText {
		font-family: PingFang SC, PingFang SC;
		line-height: 54px;
		font-weight: 500;
		font-size: 18px;
		color: #333333;
	}

	.crumbsText {
		margin-left: auto;
		font-size: 14px;
		line-height: 54px;
		cursor: pointer;
		color: #4568dc;
	}

	.crumbsText span {
		color: #6c757d;
		cursor: auto;
	}

	.drawerTable {
		margin: 20px 0;
		/* padding: 10px; */
		box-sizing: border-box;
	}

	.box-card /deep/ .el-card__body {
		box-sizing: border-box;
	}
	/* 抽屉遮罩框样式 */
	.drawerContent {
		padding-right: 50px;
	}
	
	.drawerTipsTitle {
		font-weight: 500;
		font-size: 16px;
		color: #333333;
		margin-bottom: 12px;
	}
	
	.titleRow {
		display: flex;
		justify-content: space-between;
		margin-top: 24px;
	}
	
	.downloadBtn {
		font-weight: 500;
		font-size: 14px;
		color: #1990FE;
		cursor: pointer;
	}
	
	.drawerContBox {
		border: 1px solid #EAEFF5;
	}
	
	.drawTableRow,
	.drawTableRowTwo {
		background: #F7F8F9;
		height: 47px;
		border-bottom: 1px solid #EAEFF5;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 0 16px;
	}
	
	.drawTableRowTwo {
		background: none;
		border: none;
	}
	
	.rowContent {
		font-weight: 600;
		font-size: 14px;
		color: #666666;
		margin-right: 40px;
	}
	
	.fileCont {
		width: 280px;
		height: 28px;
		font-family: PingFang SC, PingFang SC;
		background: #F7F7F7;
		font-weight: 500;
		font-size: 12px;
		color: #333333;
		line-height: 28px;
		padding-left: 4px;
		white-space: nowrap; 
		overflow: hidden; 
		text-overflow: ellipsis; 
		cursor: pointer;
	}
</style>
